import React from "react";
import Calendar from "react-calendar";

const DashboardCalendar = () => {
  return (
    <div className="dashboard_calendar_container">
      <Calendar />
    </div>
  );
};

export default DashboardCalendar;
